export default {
  STORY_LAUNCH_SELF_ASSIGNED: 'storyLaunchSelfAssigned',
  STORY_LAUNCH_ASSIGNED: 'storyLaunchAssigned',
  TESTLET_LAUNCH_ASSIGNED: 'testletLaunchAssigned',
  STORY_PICKER_OPENED: 'storyPickerOpened',
  STORY_PICKED: 'storyPicked',
  STORY_FETCHED: 'storyFetched',
  TESTLET_FETCHED: 'testletFetched',
  NEXT_TESTLET_FETCHED: 'nextTestletFetched',
  NO_SUBSEQUENT_TESTLET: 'noSubsequentTestlet',
  STORY_CHANGE: 'storyChange',
  STORY_START: 'storyStart',
  STORY_END: 'storyEnd',
  PHRASE_START: 'phraseStart',
  PHRASE_PAUSE: 'phrasePause',
  PHRASE_RESUME: 'phraseResume',
  WORD_INCREMENT: 'wordIncrement',
  WORD_SKIP: 'wordSkip',
  WORD_INDEX_CHANGE: 'wordIndexChange',
  PHRASE_INCREMENT: 'phraseIncrement',
  PAGE_INCREMENT: 'pageIncrement',
  INTERVENTION_ON_PHRASE: 'interventionOnPhrase',
  INTERVENTION_ON_WORD: 'interventionOnWord',
  INTERVENTION_ABORT: 'interventionAbort',
  OPEN_MODAL: 'openModal',
  CLOSE_MODAL: 'closeModal',
  ENABLE_RECORDING: 'enableRecording',
  SEND_RECORDING: 'sendRecording',
  SEND_TESTLET_RECORDING: 'sendTestletRecording'
}